import {RiderView} from '@app/facade-services/rider-view/model/rider-view';
import {DataItem} from '@app/components/shared/model/data-item';
import {KombinationstypEnum} from '@app/constants/kombinationstyp';
import {Fence} from '@app/rest-client/faxe/models/fence';
import {RaceClass} from '@app/rest-client/faxe/models/race-class';
import { getRiderLastFenceName, getRiderLastFenceSequence } from '@app/domain/functions';
import { stringToNumber } from '@app/fremework/functions';


export const mapRiderView = (riderView: RiderView): DataItem<RiderView> =>
  riderView ? ({
    key: riderView.riderGuid,
    displayname: riderView.horseCombinationNumber.toString(),
    kombinationstypEnum: KombinationstypEnum.must1of1,
    value: riderView,
    sortOrder: getRiderLastFenceSequence(riderView),
    badge: getRiderLastFenceName(riderView)
  }) : undefined;

export const mapFence = (fence: Fence): DataItem<Fence> =>
  fence ? ({
    key: fence?.fenceGuid,
    displayname: fence?.fenceName,
    value: fence,
    sortOrder: fence?.sequence
  }) : undefined;

export const mapRaceClass = (raceClasses: RaceClass[]): DataItem<RaceClass>[] =>
  raceClasses?.sort((a, b) => stringToNumber(a.raceClassNumber) - stringToNumber(b.raceClassNumber))
    ?.map(rc => ({
      displayname: `${rc.raceClassNumber}  (${rc.raceClassName})`,
      key: rc.raceClassGuid,
      value: rc,
      sortOrder: stringToNumber(rc.raceClassNumber)
    }));

